module.exports = __webpack_public_path__ + "img/f2e55ee.jpg";